<a class="mb-3 d-flex align-items-center gap-half" (click)="location.back()">
  <web-design-system-icon name="chevron-3" color="action" />
  <span class="zero-text link p-base-med">{{ 'back-link' | transloco }}</span>
</a>
